import { pushGateway, type RegisterTokenOptions } from '@/api';
import { STORAGE_PUSH_KEY } from '@/utils/constants/storage-push-key';

const onUserLogin = async (): Promise<void> => {
	const storedOptions = localStorage.getItem(STORAGE_PUSH_KEY);
	if (!storedOptions) return;

	try {
		const options: RegisterTokenOptions = JSON.parse(storedOptions);
		await pushGateway.registerToken(options);
	} catch (error) {}
};

const onUserLogout = async (): Promise<void> => {
	const storedOptions = localStorage.getItem(STORAGE_PUSH_KEY);
	if (!storedOptions) return;

	try {
		const options: RegisterTokenOptions = JSON.parse(storedOptions);
		await pushGateway.unregisterToken(options.token);
	} catch (error) {}
};

const PushGatewayService = {
	onUserLogin,
	onUserLogout
};

export { PushGatewayService };
